import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { cssClass } from '@/shared/utils'
import {
  emptyStateImage,
  notificationHeaderBackground,
} from 'containers/highlights/styles/highlight.css'
import { useProfile } from 'containers/profile/hooks/useProfile'
import Image from 'next/image'
import { joinWithSlash } from 'utilities/links'

interface ProjectEmptyStateProps {
  className?: string
}

export const ProjectEmptyState = ({ className }: ProjectEmptyStateProps) => {
  const { profile } = useProfile()

  return (
    <div className={className}>
      <div
        className={cssClass([
          'py-12 px-24 rounded-t-12',
          notificationHeaderBackground,
        ])}
      >
        <Title variation="small" colorClass="text-accent-primary">
          Creatorland Projects
        </Title>
      </div>

      <div className="p-24 bg-white-primary rounded-12">
        <Title sizeClass="text-20--tablet text-18">
          Tell in-depth success stories with Projects!
        </Title>

        <Text
          colorClass="text-secondary"
          sizeClass="text-14--tablet text-12"
          className="mt-8"
        >
          Projects allow you to comprehensively showcase your skills and
          achievements. While Highlights spotlight specific successes, Projects
          provide a detailed canvas to narrate your creative journey and impress
          potential partners.
        </Text>

        <div className="mt-32--tablet mt-22 flex justify-center">
          <div className={cssClass(['relative', emptyStateImage])}>
            <Image
              src={IMAGE_PATHS_V2.profileV2 + 'bg_empty_projects.png'}
              alt="Empty Projects - invite to create projects"
              fill
              style={{
                objectFit: 'contain',
              }}
              sizes="(max-width: 592px) 90vw, 546px"
              className="rounded-10"
            />
          </div>
        </div>

        <div className="flex items-center justify-center mt-32">
          <ButtonComponent
            variation="primary"
            size="small"
            className="productFruits-project-tour"
            label="Create your first Project"
            to={joinWithSlash(
              profile?.username?.toLocaleLowerCase(),
              'projects',
              'create'
            )}
          />
        </div>
      </div>
    </div>
  )
}
